import encode from '../worker/wp2Encode';
export const wp2Encode = (imageData, options) => encode(imageData, options);
